import React, { useCallback } from "react";
import { View, Text, Pressable, StyleSheet } from "../platformComponents";
import { ModalBase } from "@aspen/ui";
import { i18nCrossUtil, tranformPx } from "@adgm/libs";
import { CommonButton } from "../common/CommonButton";
import { ModalGoToEdgenAiContent } from "./ModalGoToEdgenAiContent";
import { colors, fontFamily, fontWeight } from "../styles/common";
import { TModalGoToEdgenAIProps } from "./index";
import { GA_EVENT_NAME, reportEvent } from "@aspen/libs";

export const ModalGoToEdgenAI: React.FC<TModalGoToEdgenAIProps> = ({
  visible,
  onClose,
  onConfirm,
}) => {
  const crossIntl = i18nCrossUtil.t();
  const edgenUrl = crossIntl["third.party.service.warning.intro.url"];

  /**
   * 处理URL点击事件 - Web端：使用window.open打开新页面
   */
  const handleUrlPress = useCallback(() => {
    if (edgenUrl && typeof window !== "undefined" && window.open) {
      window.open(edgenUrl, "_blank");
    }
  }, [edgenUrl]);

  const handleConfirm = useCallback(() => {
    onConfirm();
    reportEvent({ moduleName: GA_EVENT_NAME.common.goToEdgenAI });
  }, [onConfirm]);

  const handleCancel = useCallback(() => {
    onClose && onClose();
  }, [onClose]);

  return (
    <ModalBase
      open={visible}
      onCancel={onClose}
      width={580}
      footer={null}
      title={null}
      centered
      closable={false}
      maskClosable={false}
      className="third-party-service-warning-modal">
      <View style={styles.container}>
        {/* 使用跨端公共内容组件 */}
        <ModalGoToEdgenAiContent scrollViewHeight={335} onUrlPress={handleUrlPress} />

        {/* 确认按钮 */}
        <CommonButton
          onPress={handleConfirm}
          text={crossIntl["third.party.service.warning.button.confirm"]}
          style={styles.button}
          enableBackgroundColor={colors.highlightColor}
        />

        {/* 取消按钮 */}
        <Pressable onPress={handleCancel} style={styles.cancelButton}>
          <Text style={styles.cancelButtonText}>
            {crossIntl["third.party.service.warning.button.cancel"]}
          </Text>
        </Pressable>
      </View>
    </ModalBase>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingTop: 8,
  },
  button: {
    marginTop: 24,
    borderRadius: tranformPx(4),
  },
  cancelButton: {
    marginTop: tranformPx(16),
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer" as any,
  },
  cancelButtonText: {
    fontSize: tranformPx(14),
    lineHeight: tranformPx(22),
    fontFamily: fontFamily.commonRegular,
    fontWeight: fontWeight.f400,
    color: colors.white16,
    textAlign: "center",
  },
});

export type { TModalGoToEdgenAIProps };
